import { useIsSaber } from '../utils/qualSistema';
import configUrlSetor from './urls/configUrlSetor';

export const useSetorRoutes = () => {
  const isSaber = useIsSaber();

  // Prefixo dinâmico dependendo do layout
  const layoutPrefix = isSaber ? '/saber' : '/site/admin';

  return {
    SETOR_CREATE: isSaber ? configUrlSetor.SETOR_CREATE_SABER : configUrlSetor.SETOR_CREATE_SITE,
    SETOR_EDIT: isSaber ? configUrlSetor.SETOR_EDIT_SABER : configUrlSetor.SETOR_EDIT_SITE,
    SETOR_LIST: isSaber ? configUrlSetor.SETOR_LIST_SABER : configUrlSetor.SETOR_LIST_SITE,
    SETOR_EDIT_LK: isSaber ? configUrlSetor.SETOR_EDIT_LK_SABER : configUrlSetor.SETOR_EDIT_LK_SITE,
    SETOR_LOGO: isSaber ? configUrlSetor.SETOR_LOGO_SABER : configUrlSetor.SETOR_LOGO_SITE,

    SETOR_FILTER_BY_SEARCH_EP: configUrlSetor.SETOR_FILTER_BY_SEARCH_EP, // não muda com layout
    SETOR_API_EP: configUrlSetor.SETOR_API_EP // não muda com layout
  };
};
